module.exports = __webpack_public_path__ + "static/media/female.c13b6eba.ogg";